import { Component, Input } from '@angular/core';
import { AppUser } from '../../models/app-user.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilService } from '../../services/util.service';
import { HouseFlat } from '../../models/house-flat.model';
import { StreetBuilding } from '../../models/street-building.model';

@Component({
  selector: 'app-user-view-modal',
  templateUrl: './user-view-modal.component.html',
  styleUrl: './user-view-modal.component.scss'
})
export class UserViewModalComponent {

  @Input() user?: AppUser;
  @Input() streetBuilding?: StreetBuilding;
  @Input() houseFlat?: HouseFlat;
  public showPassword: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public utilService: UtilService,
  ) {
  }

}
